import styled from 'astroturf/react';
import PopupComponent from 'src/components/Popup';
import Svg from 'src/components/Svg';

const TopInfoBlock = styled('div')`
  text-align: center;
  font-size: small;

  & > button {
    height: 2.5em;
    font-size: small;
  }

  & > button:active {
    color: var(--ph-orange-500);
    background-color: var(--white);
  }
`;

const Container = styled('div')`
  width: 100%;
  overflow-x: auto;
  margin-top: 1em;
  margin-bottom: 1em;

  &.readOnly *{
    color: var(--ph-gray-200);
    pointer-events: none;
  }
`;

const DragDropContainer = styled(`div`)`
  display: flex;
  flex-direction: column;
  padding: 0;
`;

const Grid = styled('div')`
  display: flex;
  width: 100%;
`;

const ImageHolder = styled('div')`
  width: calc(33.33% - 5px);
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 3px 5px 0 0;
`;

const Figure = styled('figure')`
  position: relative;
  border: 2px solid black;
  display: flex;
  flex-flow: column;
  width: 100%;
  overflow: hidden;
  justify-content: center;
  margin: 0 0.25em;
  height: 100%;

  &.border_light {
    border: 1px solid var(--ph-gray-300);
  }
`;

const Image = styled('img')`
  object-fit: contain;
  height: 100%;
  max-height: 20em;
  margin: 5px;
  cursor: pointer;

  &:active {
    opacity: 0.5;
  }

  &.small {
    height: 12rem;
  }
`;

const ImageDiv = styled('div').attrs(
  ({ backgroundImage, ...props }) => {
    return {
      ...props,
      style: {
        backgroundImage: `url("${backgroundImage}")`
      },
    };
  })`
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  max-height: 20em;
  margin: 5px;
  cursor: pointer;

  &:active {
    opacity: 0.5;
  }

  &.small {
    height: 12rem;
  }
`;

const FigureCaption = styled('figcaption')`
  border-top: 2px solid black;
  height: 2em;
  max-height: 20%;
  line-height: 1.2em;
  margin-top: 2px;
  margin-bottom: 2px;
  overflow: auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

const ImageUploadButton = styled('div')`
  display: none;
`;

const ImageActions = styled('div')`
  color: #929497;
`;

const FormPopup = styled(PopupComponent)`
  left: initial;
  top: initial;
  height: 100vh;
  width: 100vw;
  max-height: initial;

  div[id*="icon-cross"] {
    z-index: 999;
  }
`;

const Title = styled('h1')`
  font-size: var(--ph-heading-five);
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);
  margin-top: 0;
  margin-bottom: 0;

  &.u-mt-30 {
    margin-top: 30px;
  }
`;

const Table = styled('table')`
  border-radius: var(--ph-border-radius-sm);
  background-color: var(--white);
  width: 100%;
  font-size: var(--ph-text-sm);
  box-shadow: var(--ph-box-shadow-sm);
  border-collapse: collapse;

  thead {
    border-radius: var(--ph-border-radius-sm);
    background-color: var(--ph-gray-100);
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: var(--white);
    padding: 0 10px;
  }

  td {
    border: 0;
    padding: 5px 10px;
  }
`;

const LinkedQuestionsIndicator = styled('div')`
  background-color: var(--ph-gray-800);
  opacity: 0.5;
  position: absolute;
  width: 12%;
  height: 15%;
  align-self: flex-end;
  bottom: 3rem;
`;

const LinkedQuestionsIndicatorIcon = styled(Svg)`
  width: 50%;
  height: 1rem;

  path,
  g {
    stroke: var(--white);
  }
`;

export default {
  Container,
  DragDropContainer,
  Figure,
  FigureCaption,
  FormPopup,
  Grid,
  Image,
  ImageActions,
  ImageDiv,
  ImageHolder,
  ImageUploadButton,
  Table,
  Title,
  TopInfoBlock,
  LinkedQuestionsIndicator,
  LinkedQuestionsIndicatorIcon,
};
